import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SignalRService from "../../one-query/services/SignalRService";
import {
  useGenerateWorkflowTextSuitesResponse,
  useGetWorkFlow,
} from "../../../store/Apis/WorkflowsApi";
import {
  Box,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { ClearIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ClearIcon";
import ArrowBackIcon from "../../../Custom-imeges/ArrowBack";
import { PromptEngineerIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/PromptEngineerIcon";
import { ParaphraseIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/ParaphraseIcon";
import { SummarizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/SummarizeIcon";
import { HumanizeIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/HumanizeIcon";
import { TranslatorIcon } from "../../../Custom-imeges/SuitesIcons/TextSuitesIcons/TranslatorIcon";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import GreaterThanIcon from "../../../Custom-imeges/GreaterThanIcon";
import {
  FinishMark,
  ImageSuiteApps,
  MessageType,
  TextSuiteApps,
  WorkflowAppInputAndOutputTypes,
  WorkflowAppType,
} from "../../../Helper";

import DoneIcon from "@mui/icons-material/Done";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ChatResponseFormat from "../../main-page/components/get-conversation/ChatResponseFormat";
import {
  setGenerateingResponse as setGeneratingResponse,
    setIsWorkflowRunFinished,
    setSelectedWorkflowData,
    setSelectedWorkflowRun,
} from "../../../store/one-query/workflowsSlice";
import LeftScrollIcon from "../../../Custom-imeges/Workflows-Icons/leftScrollIcon";
import RightScrollIcon from "../../../Custom-imeges/Workflows-Icons/RightScrollIcon";
import {
  OptionBtnIconStyle,
  tooltipStyles,
} from "../../TextSuite/Components/TextSuitesBody";
import { OutputImage } from "../../ImageSuite/Components/Shared/OutputImage";
import { GenerateImgIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateImgIcon";
import { GenerateLogoIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateLogoIcon";
import { GenerateIconIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIconIcon";
import { GenerateIllsturationsIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/GenerateIllsturationsIcon";
import { BgRemoverIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/BgRemoverIcon";
import { ImageRestoreIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageRestoreIcon";
import { ImageTranscaptionIcon } from "../../../Custom-imeges/SuitesIcons/ImageSuiteIcons/GenerationExamples/ImageTranscaptionIcon";
import { UploadImageModal } from "../../ImageSuite/Components/Shared/UploadImageModal";
import { ExpandGeneratedImageModal } from "../../ImageSuite/Components/Shared/ExpandGeneratedImageModal";
import { useGetUserCredits } from "../../../store/Apis/StripeApi";
import OutputVideo from "../../VideoSuite/Components/Shared/OutputVideo";
import { getVideoSuiteType, VideoSuiteApps } from "../../../Types/VideoSuite-Types";
import TextToVideoIcon from "../../../Custom-imeges/VideoSuite/TextToVideoIcon";
import ImageToVideoIcon from "../../../Custom-imeges/VideoSuite/ImageToVideoIcon";
import { InputText } from "../../ImageSuite/Components/Shared/InputText";
import { useGenerateRandomPrompt } from "../../../store/Apis/SuitesApps/ImageSuitesApi";
import { useImproveVideoSuitePrompt } from "../../../store/Apis/SuitesApps/VideoSuiteApi";
import { imageToVideoInputInterface, imageToVideoInputType, WorkflowSharedView } from "../../../Helpers/WorkflowHelper";
export interface appsDataTypes {
  appId:string;
  appType: string;
  suiteType: number;
  inputType: string;
  outputType: string;
  appOrder: number;
  input: string;
  output: string;
  isFinished: boolean;
}
export const OptionBtnIconStyleResponseFinished = {
  width: "16px",
  height: "16px",
  color: "#FFF",
};

const getAppSelected = (title: string, className?: string) => {
  switch (title) {
    case TextSuiteApps.Translator:
      return (
        <TranslatorIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case TextSuiteApps.Humanizer:
      return (
        <HumanizeIcon
          className={`${className ? className : "text-nav-item-icon-stroke"}`}
        />
      );
    case TextSuiteApps.Summarizer:
      return (
        <SummarizeIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case TextSuiteApps.Paraphraser:
      return (
        <ParaphraseIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case TextSuiteApps.PromptGenerator:
      return (
        <PromptEngineerIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case ImageSuiteApps.TextToImage:
      return (
        <GenerateImgIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case ImageSuiteApps.LogoGenerator:
      return (
        <GenerateLogoIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case ImageSuiteApps.IconGenerator:
      return (
        <GenerateIconIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case ImageSuiteApps.IllustrationGenerator:
      return (
        <GenerateIllsturationsIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case ImageSuiteApps.BackgroundRemover:
      return (
        <BgRemoverIcon
          className={`${className ? className : "text-nav-item-icon-stroke"}`}
        />
      );
    case ImageSuiteApps.ImageRestore:
      return (
        <ImageRestoreIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case TextSuiteApps.TextExtraction:
      return (
        <ImageTranscaptionIcon
          className={`${className ? className : "text-nav-item-icon"}`}
        />
      );
    case VideoSuiteApps.TextToVideo:
      return (
         <TextToVideoIcon  
         className={`${className ? className : "text-nav-item-icon"}`} />
      );
    case VideoSuiteApps.ImageToVideo:
      return (
         <ImageToVideoIcon  
         className={`${className ? className : "text-nav-item-icon"}`} />
      );
    default:
      return null;
  }
};

interface WorkflowDetailsProp {
  view?: string;
}

const WorkflowDetails = ({view}:WorkflowDetailsProp) => {
  const getUserCredits = useGetUserCredits();
  const outputVideoRef = useRef<HTMLVideoElement | null>(null)
  const [selectedAppOrder, setSelectedAppOrder] = useState<number>(1);
  const [prompt, setPrompt] = useState<string>("");
  const { workflowId } = useParams<{ workflowId: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const GenerateWorkflowResponseTextSuites =
    useGenerateWorkflowTextSuitesResponse();
  const [clearData, setClearData] = useState<boolean>(false);
  const { data:selectedWorkflowData } = useGetWorkFlow(workflowId || "");
  const [selectedWorkflowDetails, setSelectedWorkflowDetails] = useState<
    appsDataTypes[]
  >([]);
  const allTextSuitesApps = useAppSelector((s) => s.workflows.textSuitesApps);
  const selectedWorkflowRun = useAppSelector(
    (s) => s.workflows.selectedWorkflowRun
  );
  const isGenerateFinished =
    selectedWorkflowDetails.length > 0
      ? selectedWorkflowDetails?.every((app) => app.isFinished)
      : false;
  
  const [isOutputCoped, setIsOutputCoped] = useState<boolean>(false);
  const selectedApp = selectedWorkflowDetails.find(
    (app) => app.appOrder === selectedAppOrder
  );
  const dispatch = useAppDispatch();
  const [saveOrderAndOutput, setSaveOrderAndOutput] = useState<{
    order: number;
    output: string;
  }>({ order: 0, output: "" });
  const [isScrollable, setIsScrollable] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);
  const [inputImage, setInputImage] = useState<File | string | null>(null);
  const [isGenerateImgLoading, setIsGenerateImgLoading] = useState(false);
  const [expandOutputImage, setExpandOutputImage] = useState(false);
  const [inputValue,setInputValue]=useState<string |null>(null);
  const IsAuthenticated=useAppSelector((s)=>s.User.IsAuthenticated)
  const { mutate: GenerateRandomPrompt, isPending: IsGeneratePromptLoading } =
    useGenerateRandomPrompt();
  const {
    mutate: ImproveVideoPromptRequest,
    isPending: isVideoPromptImproving,
  } = useImproveVideoSuitePrompt();
  const workflowSlice = useAppSelector((s) => s.workflows);

  useEffect(() => {
    if (selectedWorkflowData) {
      dispatch(setSelectedWorkflowData(selectedWorkflowData))
    }
  },[selectedWorkflowData])

  useEffect(() => {
    const checkScroll = () => {
      if (containerRef.current) {
        const { scrollWidth, clientWidth, scrollLeft } = containerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
      }
    };

    checkScroll(); // Initial check
    if (containerRef.current) {
      containerRef.current.addEventListener("scroll", checkScroll);
    }

    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
      if (containerRef.current) {
        containerRef.current.removeEventListener("scroll", checkScroll);
      }
    };
  }, [selectedWorkflowDetails]);

  useEffect(() => {
    setIsLoading(false);
    handleClearWorkflow();
  }, [workflowId]);

  useEffect(() => {
    setSelectedAppOrder(1);
  }, [workflowSlice.selectedWorkflowData]);
  const handelGenerateRandomPrompt = async () => {
    setInputValue("");
    const connectionId = await SignalRService.getInstance().getConnectionId();
    const RequestData = {
      connectionId: connectionId,
      type: getVideoSuiteType(true) + "",
    };
    GenerateRandomPrompt(RequestData);
  };
  const handleRunWorkflow = async () => {
    if (
      selectedWorkflowDetails[0]?.input?.trim() ||
      (inputImage && !isLoading)
    ) {
      setSelectedAppOrder(1);
      setIsLoading(true);
      dispatch(setGeneratingResponse(true));
      const connectionId = await SignalRService.getInstance().getConnectionId();
      const formData = new FormData();
      formData.append("workflowId", workflowSlice.selectedWorkflowData?.id);
      formData.append("connectionId", connectionId);
      if (
        selectedWorkflowDetails?.length === 1 &&
        selectedWorkflowDetails[0]?.appType === VideoSuiteApps?.ImageToVideo &&
        inputImage &&
        inputValue &&
        connectionId &&
        !isLoading
      ) {
        formData.append("image", inputImage);
        formData.append("prompt", inputValue);
        GenerateWorkflowResponseTextSuites(formData);
      }
      if (
        selectedApp?.inputType === WorkflowAppInputAndOutputTypes.Image &&
        inputImage &&
        connectionId &&
        !isLoading
      ) {
        formData.append("image", inputImage);
        GenerateWorkflowResponseTextSuites(formData);
      } else if (
        selectedApp?.inputType === WorkflowAppInputAndOutputTypes.Text &&
        prompt.length > 0 &&
        connectionId &&
        !isLoading
      ) {
        formData.append("prompt", prompt);
        GenerateWorkflowResponseTextSuites(formData);
      }
    }
  };

  const handleClearWorkflow = () => {
    setClearData(true);
    setIsLoading(false);
    setSelectedAppOrder(1);
    setInputImage(null);
    const newApps = workflowSlice.selectedWorkflowData?.apps?.map((app: any) => ({
      appId: app.appId,
      appType: app.appType,
      suiteType: app.suiteType,
      appOrder: app.appOrder,
      inputType: app.inputType,
      outputType: app.outputType,
      input: "",
      output: "",
      isFinished: false,
    }));
    if (newApps) setSelectedWorkflowDetails(newApps); // Set state only once
  };
  const handleClearSelectedWorkflowRun = () => {
    dispatch(
      setSelectedWorkflowRun({
        id: "",
        workflowId: "",
        name: "",
        createdAt: "",
        workflowAppResults: [],
      })
    );
  };
  useEffect(() => {
    const currentWorkflowApps = workflowSlice.selectedWorkflowData?.apps
    const shouldInitialize = currentWorkflowApps?.length > 0;
    if (shouldInitialize) {
     setInputValue("");
     setInputImage(null)
        const newApps = currentWorkflowApps.map(
        (app: any, index: number) => {
          const runApp = selectedWorkflowRun?.workflowAppResults?.[index];
            let inputValue = runApp?.input;
            if (app?.inputType === imageToVideoInputType) {
              const appInputParams: imageToVideoInputInterface = JSON.parse(runApp?.input || '{}');
              if (currentWorkflowApps?.length > 0 &&
                currentWorkflowApps[index - 1]?.outputType === WorkflowAppInputAndOutputTypes.Text) {
                inputValue = appInputParams?.InputText || "";
              } else if (currentWorkflowApps?.length > 0 &&
                currentWorkflowApps[index - 1]?.outputType === WorkflowAppInputAndOutputTypes.Image) {
                inputValue = appInputParams?.InputImage || "";
              } else {
                setInputValue(appInputParams?.InputText);
                setInputImage(appInputParams?.InputImage)
              }
            }
          return {
            appId: app.id,
            appType: app.appType,
            suiteType: app.suiteType,
            appOrder: app.appOrder,
            inputType: app.inputType,
            outputType: app.outputType,
            input: inputValue || "",
            output: runApp?.output || "",
            isFinished: !!runApp,
          };
        }
      );

      if (newApps) setSelectedWorkflowDetails(newApps);
      setSaveOrderAndOutput({
        order: newApps[newApps?.length - 1]?.appOrder,
        output: newApps[newApps?.length - 1]?.output,
      });
    }
  }, [workflowSlice.selectedWorkflowData, selectedWorkflowRun, workflowId]);

  useEffect(() => {
    if (
      saveOrderAndOutput?.order > 0 &&
      saveOrderAndOutput?.order < selectedWorkflowDetails.length &&
      saveOrderAndOutput?.output.length > 0
    ) {
      setSelectedWorkflowDetails((prev) =>
        prev.map((app) =>
          app.appOrder === saveOrderAndOutput.order + 1
            ? { ...app, input: saveOrderAndOutput.output }
            : app
        )
      );
    }
  }, [saveOrderAndOutput]);

    const handleGenerateVideoSuitesSignalR = useCallback(
      (
         message:string,
         messageType:number,
         tag: string,
      ) => {
         if (messageType === MessageType.VideoSuiteWorkflow) {
        if (message == "**/**Finished**/**") getUserCredits();
        // Extract app name and order from the tag
        const [appType, suiteType, appOrderStr] = tag.split("-");
        const appOrder = Number(appOrderStr);
        const appSuiteType = Number(suiteType);
        setSelectedWorkflowDetails((prevDetails) =>
          prevDetails.map((app) => {
            if (
              appOrder === prevDetails.length &&
              message === "**/**Finished**/**"
            ) {
              dispatch(setGeneratingResponse(false));
              setIsLoading(false);
              setIsGenerateImgLoading(false);
            }
            if (
              app.appType === appType &&
              app.appOrder === appOrder &&
              appSuiteType === app.suiteType
            ) {
              if (message === "**/**Finished**/**") {
                setSaveOrderAndOutput({
                  order: appOrder,
                  output: app.output,
                });
                return { ...app, isFinished: true };
              } else {
                setSelectedAppOrder(appOrder);
                setIsLoading(true);
                setIsGenerateImgLoading(true);
                return { ...app, output: app.output + message };
              }
            }
            return app;
          })
        );
      }
    },
    []
    );
  
    const setupSignalRVideoAppsConnection = useCallback(() => {
      const connection = SignalRService.getInstance().connection;
      connection.on("SendVideoMessage", handleGenerateVideoSuitesSignalR);
      return () => {
        connection.off("SendVideoMessage", handleGenerateVideoSuitesSignalR);
      };
    }, [handleGenerateVideoSuitesSignalR]);
  
    useEffect(() => {
      const cleanup = setupSignalRVideoAppsConnection();
      return () => {
        cleanup();
      };
    }, [setupSignalRVideoAppsConnection]);
  

  // Signal-R functions.
  const handleTextSuitesWorkflow = useCallback(
    (
      modelName: string,
      modelVersion: string,
      message: string,
      tag: string,
      conversationId: string,
      messageId: string,
      messageType: number
    ) => {
      if (messageType === MessageType.Utility && message !== FinishMark && message !== null) {
        setInputValue((prev) => (prev ? prev + message : message));
      }
      if (
        messageType === MessageType.TextSuiteWorkflow ||
        messageType === MessageType.ImageSuiteWorkflow
      ) {
        if (message == FinishMark) getUserCredits();
        // Extract app name and order from the tag
        const [appType, suiteType, appOrderStr] = tag.split("-");
        const appOrder = Number(appOrderStr);
        const appSuiteType = Number(suiteType);
        setSelectedWorkflowDetails((prevDetails) =>
          prevDetails.map((app) => {
            if (
              appOrder === prevDetails.length &&
              message === FinishMark
            ) {
              dispatch(setGeneratingResponse(false));
              setIsLoading(false);
              setIsGenerateImgLoading(false);
            }
            if (
              app.appType === appType &&
              app.appOrder === appOrder &&
              appSuiteType === app.suiteType
            ) {
              if (message === FinishMark) {
                setSaveOrderAndOutput({
                  order: appOrder,
                  output: app.output,
                });
                return { ...app, isFinished: true };
              } else {
                setSelectedAppOrder(appOrder);
                setIsLoading(true);
                setIsGenerateImgLoading(true);
                return { ...app, output: app.output + message };
              }
            }
            return app;
          })
        );
      }
    },
    []
  );

  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendModelMessage", handleTextSuitesWorkflow);
    return () => {
      connection.off("SendModelMessage", handleTextSuitesWorkflow);
    };
  }, [handleTextSuitesWorkflow]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);

  // ==============================================================

  // signalR to replace old image url with new AzureImage url, firts for performance BE save image locally,
  //  then to azure, after azure finish we remove drive image and replace it ith azure.
  const handleReplaceImageURL = useCallback(
    (
      messageId: string,
      responseId: string,
      oldImageUrl: string,
      newImageUrl: string,
      messageType: number
    ) => {
      if (messageType === MessageType.ImageSuiteWorkflow) {
        // replace old input image url with new input image url in the workflow details
        setSelectedWorkflowDetails((prevDetails) =>
          prevDetails.map((app) =>
            app.input === oldImageUrl ? { ...app, input: newImageUrl } : app
          )
        );
        // replace old output image url with new output image url in the workflow details
        setSelectedWorkflowDetails((prevDetails) =>
          prevDetails.map((app) =>
            app.output === oldImageUrl ? { ...app, output: newImageUrl } : app
          )
        );
      }
    },
    []
  );

  const replaceURLImageSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("ReplaceOldImageUrl", handleReplaceImageURL);
    return () => {
      connection.off("ReplaceOldImageUrl", handleReplaceImageURL);
    };
  }, []);

  useEffect(() => {
    const cleanup = replaceURLImageSignalRConnection();
    return () => {
      cleanup();
    };
  }, [replaceURLImageSignalRConnection]);

  //===============================================================
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (selectedApp?.appOrder === 1) {
      setSelectedWorkflowDetails((prevDetails) =>
        prevDetails.map((app) =>
          app.appOrder === 1 ? { ...app, input: newValue } : app
        )
      );
      setPrompt(newValue);
    }
  };

  const handleCopyOutput = () => {
    if (selectedApp?.output) {
      navigator.clipboard.writeText(selectedApp.output);
      setIsOutputCoped(true);
      setTimeout(() => {
        setIsOutputCoped(false);
      }, 1000);
    }
  };

  const handleSetActiveApp = (app: number) => {
    if (saveOrderAndOutput.output.length > 0 && !isLoading) {
      setSelectedAppOrder(app);
    }
  };

  const handleInputImageChange = (image: File | null) => {
    if (image) {
      setInputImage(image);
      const imagePath = URL.createObjectURL(image);
      setSelectedWorkflowDetails((prevDetails) =>
        prevDetails.map((app) =>
          app.appOrder === 1 ? { ...app, input: imagePath } : app
        )
      );
    }
  };

  const handleClearInputImage = () => {
    setInputImage(null);
    setSelectedWorkflowDetails((prevDetails) =>
      prevDetails.map((app) =>
        app.appOrder === 1 ? { ...app, input: "" } : app
      )
    );
  };

  const handleOpenExpandImage = () => {
    setExpandOutputImage(true);
  };

  const handleCloseExpandImage = () => {
    setExpandOutputImage(false);
  };

  const handelImprovePrompt = async () => {
    const connectionId = await SignalRService.getInstance().getConnectionId();
    if (inputValue) {
      const improvePromptRequestData = {
        prompt: inputValue,
        connectionId: connectionId,
      };
      ImproveVideoPromptRequest(improvePromptRequestData);
      setInputValue("");
    }
  };

  useEffect(() => {
    dispatch(setIsWorkflowRunFinished(isGenerateFinished));
  },[isGenerateFinished])

  return (
    <Box sx={{ width: "100%", height: "98%" }}>
      <Box className="text-suites-navbar justify-content-between position-relative">
        {isScrollable && !atStart && (
          <button
            className="scroll-leftDetails"
            onClick={() =>
              containerRef.current?.scrollBy({ left: -100, behavior: "smooth" })
            }
          >
            <LeftScrollIcon className="custom-icon" />
          </button>
        )}
        <Box
          className={`workflow-navbar-details ${view}`}
          sx={{ overflowX: "auto" }}
          ref={containerRef}
        >
          {selectedWorkflowDetails?.map((app, i) => (
            <Box
              key={i}
              onClick={() => handleSetActiveApp(app.appOrder)}
              className="workflow-navbar-item"
            >
              <Box
                className={`workflow-app-nav-Item ${
                  selectedAppOrder === app.appOrder && "active"
                } ${app.appType?.toLowerCase()} `}
                style={{ textDecoration: "none !important" }}
              >
                {app.isFinished && selectedAppOrder !== app.appOrder ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "50%",
                      backgroundColor: "#12b6ea",
                      padding: "8px",
                    }}
                  >
                    <DoneIcon sx={OptionBtnIconStyleResponseFinished} />
                  </Box>
                ) : selectedAppOrder === app.appOrder&&app.isFinished ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #12b6ea",
                      borderRadius: "50%",
                      padding: "8px",
                    }}
                  >
                    {getAppSelected(app.appType, "custom-icon-blue")}
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid",
                      opacity: "0.5",
                      borderRadius: "50%",
                      padding: "8px",
                    }}
                  >
                    {getAppSelected(app.appType)}
                  </Box>
                )}
                <span
                  className={`text-nav-item-name ${
                    app.isFinished&&"responseFinished"
                  } ${selectedAppOrder === app.appOrder && "active"}`}
                  style={{
                    textDecoration: "none !important",
                    opacity: app.isFinished ? 1 : 0.5,
                  }}
                >
                  {app.appType}
                </span>
              </Box>
              {i != selectedWorkflowDetails?.length - 1 && (
                <GreaterThanIcon className="custom-icon-stroke" />
              )}
            </Box>
          ))}
        </Box>
        {isScrollable && !atEnd && (
          <button
            className={`scroll-rightDetails ${view}`}
            onClick={() =>
              containerRef.current?.scrollBy({ left: 100, behavior: "smooth" })
            }
          >
            <RightScrollIcon className="custom-icon" />
          </button>
        )}
        {isGenerateFinished && !location.href.includes("share") ? (
          <Box
            className="container-btn-run"
            onClick={() => {
              handleClearWorkflow();
              handleClearSelectedWorkflowRun();
            }}
          >
            <span
              style={{
                width: "19px",
                height: "19px",
                margin: "2px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <ClearIcon className="custom-icon-White" />
            </span>
            <button className="btn-run">Clear</button>
          </Box>
        ) : !location.href.includes("share") ? (
          <Box
            className={`container-btn-run ${
              !selectedWorkflowDetails[0]?.input?.trim() ? "disabled" : "active"
            }`}
            onClick={handleRunWorkflow}
            sx={{
              cursor: !selectedWorkflowDetails[0]?.input?.trim()
                ? "unset"
                : "pointer",
            }}
          >
            <span>
              {isLoading ? (
                <CircularProgress
                  size={14}
                  color="inherit"
                  sx={{ marginRight: "4px" }}
                />
              ) : (
                <ArrowBackIcon className="custom-icon-blue-bold" />
              )}
            </span>
            <span className="btn-run">Run</span>
          </Box>
        ) : null}
      </Box>
      <div className={`workflow-input-output-container`}>
        <div className="workflow-input-output workflow-input">
          <Box className="workflow-box-container">
            <Typography className="container-head-title">Input:</Typography>
            {selectedApp?.inputType === WorkflowAppInputAndOutputTypes.Text ||
            (selectedWorkflowDetails[selectedAppOrder - 2]?.outputType ===
              WorkflowAppInputAndOutputTypes.Text &&
              selectedApp?.inputType?.includes(
                selectedWorkflowDetails[selectedAppOrder - 2]?.outputType
              )) ? (
              <textarea
                placeholder="Type or paste your text here.."
                className="input-workflow"
                value={
                  selectedApp?.input ||
                  (selectedAppOrder === 0 &&
                    selectedWorkflowDetails[0]?.input) ||
                  ""
                }
                onChange={handleInputChange}
                readOnly={selectedApp?.appOrder !== 1}
              ></textarea>
            ) : selectedApp?.inputType ===
                WorkflowAppInputAndOutputTypes.Image ||
              (selectedWorkflowDetails[selectedAppOrder - 2]?.outputType ===
                WorkflowAppInputAndOutputTypes.Image &&
                selectedApp?.inputType?.includes(
                  selectedWorkflowDetails[selectedAppOrder - 2]?.outputType
                )) ? (
              <>
                {selectedApp?.output ? (
                  <Box sx={{ width: "100%", height: "100%", padding: "16px" }}>
                    <img
                      className="workflow-input-image"
                      src={selectedApp.input}
                    ></img>
                  </Box>
                ) : (
                  <UploadImageModal
                    inputValue={inputImage}
                    isGenerateImgLoading={isLoading}
                    handleInputImageChange={handleInputImageChange}
                    handleClearInput={handleClearInputImage}
                    appTitle=""
                  />
                )}
              </>
            ) : selectedWorkflowDetails?.length === 1 &&
              selectedWorkflowDetails[0]?.appType ===
                VideoSuiteApps?.ImageToVideo ? (
              <>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: IsAuthenticated ? "95%" : "87.5%",
                  }}
                >
                  <Box className="container-input-video h-100">
                    <UploadImageModal
                      inputValue={inputImage}
                      handleClearInput={handleClearInputImage}
                      isGenerateImgLoading={isLoading}
                      appTitle=""
                      handleInputImageChange={handleInputImageChange}
                      videoSource={true}
                    />
                    <Box className="image-suites-input-failed">
                      <Typography className="settings-title">Prompt</Typography>
                      <InputText
                        setInputValue={setInputValue}
                        example={{
                          type: 0,
                          prompt:
                            "Describe the video content you want to generate...",
                        }}
                        inputValue={inputValue || ""}
                        handelGenerateRandomPrompt={handelGenerateRandomPrompt}
                        IsGeneratePromptLoading={IsGeneratePromptLoading}
                        isGenerateImgLoading={isLoading}
                        generatedPrompt={inputValue || ""}
                        handelImprovePrompt={handelImprovePrompt}
                        isImprovePromptDisabled={isVideoPromptImproving || inputValue?.length === 0}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            ) : null}
          </Box>
        </div>
        <div className="workflow-input-output workflow-output position-relative">
          <Box className="workflow-box-container">
            <Typography className="container-head-title">Output:</Typography>
            {selectedApp?.outputType === WorkflowAppInputAndOutputTypes.Text ? (
              <div className="workflow-output-text">
                {selectedApp?.output ||
                (selectedAppOrder === 0 &&
                  selectedWorkflowDetails[0]?.output) ? (
                  <ChatResponseFormat
                    response={
                      selectedApp?.output ||
                      (selectedAppOrder === 0 &&
                        selectedWorkflowDetails[0]?.output) ||
                      ""
                    }
                  />
                ) : (
                  <p className="workflow-output-msg">
                    The output will appear here...
                  </p>
                )}
              </div>
            ) : selectedApp?.outputType ===
              WorkflowAppInputAndOutputTypes.Image ? (
                <>
              {selectedApp.output?(<Box className="workflow-output-image-container">
                {isLoading ? (
                  <img
                    src={selectedApp?.output}
                    alt="Output"
                    className="workflow-output-image"
                  ></img>
                ) :(
                  <OutputImage
                    slider={false}
                    outputImage={true}
                    imgUrl={selectedApp?.output}
                    isLoading={false}
                    handleOpenExpandImage={handleOpenExpandImage}
                  />
                ) }
              </Box>):
              !isLoading && !selectedApp?.output&&
                (
                  <Box sx={{
                    width: "100%",
                    height: "100%",
                    padding: "16px"
                  }}>
                  <p className="workflow-output-msg">
                    The output will appear here...
                  </p>
                  </Box>
                )
              }
              </>
            ) : selectedApp?.outputType ===
              WorkflowAppInputAndOutputTypes.Video ? (
              <>
              {
               !selectedApp?.output && !isLoading? (
                 <Box sx={{
                    width: "100%",
                    height: "100%",
                    padding: "16px"
                  }}>
                <p className="workflow-output-msg">
                  The output will appear here...
                </p>
                </Box>
              )
              :(
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                    <OutputVideo
                      ref={outputVideoRef}
                      videoUrl={selectedApp?.output}
                      isLoading={isLoading}
                      generateTime={""}
                    />
                </Box>
              )}
              </>
            ) : null}
            {selectedApp?.output &&
            selectedApp.output.length > 0 &&
            selectedApp.suiteType === WorkflowAppType.TextSuite ? (
              <Box
                className="copy-all-option"
                onClick={handleCopyOutput}
                sx={{ position: "absolute", bottom: "4%", right: "4%" }}
              >
                <IconButton color="inherit" size="small">
                  <Tooltip
                    title={isOutputCoped ? "Copied" : "Copy all"}
                    arrow
                    placement="top"
                    componentsProps={tooltipStyles}
                  >
                    {isOutputCoped ? (
                      <DoneIcon sx={OptionBtnIconStyle} />
                    ) : (
                      <ContentCopyIcon sx={OptionBtnIconStyle} />
                    )}
                  </Tooltip>
                </IconButton>
              </Box>
            ) : null}
          </Box>
        </div>
      </div>
      {expandOutputImage &&
      selectedApp?.outputType === WorkflowAppInputAndOutputTypes.Image ? (
        <ExpandGeneratedImageModal
          open={expandOutputImage}
          imgSrc={selectedApp.output}
          handleClose={handleCloseExpandImage}
        />
      ) : null}
    </Box>
  );
};

export default WorkflowDetails;
